module.exports = __webpack_public_path__ + "static/media/content_bg.9e1bccc5.png";